import React, { useCallback, useEffect, useRef, useState } from 'react'
import Sidebar from '../../../components/Sidebar'
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from '@chakra-ui/react'
import Modal from 'react-modal';
import { IoClose } from "react-icons/io5";
import { Formik, Form } from 'formik';
import { getSingleConversation, replyToConversation, deleteConversation, updateTherapistName, sendAudioMessageToUser, bookmarkConvo } from '../../../services/dataApi/dataProvider';
import { formatTextWithLinks, headerProvider, showToastMessage } from '../../../common/CommonFunctions';
import { useToast } from '@chakra-ui/react'
import ReactAudioPlayer from 'react-audio-player';
import { FaCheck } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import Cookies from 'js-cookie';
import { IoMdDownload, IoMdStar } from "react-icons/io";
import { FaRegBookmark } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";
import Tooltip from '@mui/material/Tooltip';





const SingleConversation = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const toast = useToast()
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);
  const [showModal, setShowModal] = useState(false)
  const [loader, setLoader] = useState(false)
  const [conversation, setConversation] = useState()
  const [deleteAlert, setDeleteAlert] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [audioURL, setAudioURL] = useState(null);
  const [report, setReport] = useState({})
  const [isAudioURL, setIsAudioURL] = useState(false)
  const [audioFile, setAudioFile] = useState()
  const [isBookmarked, setIsBookmarked] = useState();
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };
  const [replyToUser, setReplyToUser] = useState({
    replyMessage: ''
  })
  const [isEditingTherapistName, setIsEditingTherapistName] = useState(false);
  const [volunteerName, setVolunteerName] = useState(conversation?.therapistName || '');
  const currentDate = new Date().toLocaleDateString()
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReplyToUser((inputData) => ({ ...inputData, [name]: value }))
  }
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file && (file.type.startsWith('audio/') || file.type === 'video/mp4')) {
      const url = URL.createObjectURL(file);
      setAudioFile(file);
      setIsAudioURL(true);
      setAudioURL(url);
    } else {
      alert('Please select a valid audio file.');
    }
  }

  const handleBookmarkToggle = async () => {
    const headers = headerProvider()
    const requestOptions = {
      method: "PUT",
      headers: headers,
    };
    try {
      const response = await bookmarkConvo(requestOptions, conversation.id, !conversation.bookmarked && !isBookmarked ? true : false)
      if (response.success) {
        showToastMessage(
          "Success",
          "The Bookmark Status is updated.",
          "success",
          toast
        )
      }
      else {
        showToastMessage(
          "Server Error",
          "There was an error while updating the bookmark status",
          "error",
          toast
        )
      }
      setIsBookmarked(!isBookmarked);
    } catch (error) {
      console.error('Bookmark toggle failed:', error);
    }
  };
  const handleSendAudio = async () => {
    const token = Cookies.get('token')
    const headers = new Headers();
    headers.append("X-ZUMO-AUTH", token);
    const formdata = new FormData();
    formdata.append("media", audioFile);
    formdata.append("type", "audio");
    const requestOptions = {
      method: "POST",
      headers: headers,
      body: formdata,
      redirect: "follow"
    };
    const response = await sendAudioMessageToUser(requestOptions, conversation?.id)
    if (response) {
      if (response.success) {
        setIsAudioURL(false)
        showToastMessage(
          "Success",
          "The audio message successfully sent to the user.",
          "success",
          toast
        )
      }
      else {
        showToastMessage(
          "Server Error",
          "There was an error while sending the audio.",
          "error",
          toast
        )
      }
    }
    else {
      showToastMessage(
        "Server Error",
        "There was an error while sending the audio.",
        "error",
        toast
      )
    }
  }
  const getSingleConvoData = useCallback(async () => {
    try {
      const id = location.state;
      setLoader(true)
      const headers = headerProvider()
      const response = await getSingleConversation(id, headers)
      setConversation(response?.response)
      setIsBookmarked(response?.response?.bookmarked)
      setLoader(false)
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }, [location.state])

  const handleTherapistSave = async () => {
    const headers = headerProvider()
    const convoId = location.state;
    const requestOptions = {
      method: "PUT",
      headers,
      body: JSON.stringify({ convoId, volunteerName }),
    };
    const response = await updateTherapistName(requestOptions)
    if (response) {
      if (response.success) {
        showToastMessage(
          "Therapist Name Updated",
          "The therapist name has been updated successfully.",
          "success",
          toast
        )
      }
    }
    setIsEditingTherapistName(false);
  };

  useEffect(() => {
    getSingleConvoData()
  }, [showModal, getSingleConvoData, isAudioURL])

  useEffect(() => {
    const userReport = conversation?.messages.filter((item) => {
      return item.reportType
    })
    if (userReport) {
      setReport(userReport[0])
    }
  }, [showReport])

  const openModal = () => {
    setShowModal(!showModal)
  }
  const handleDeleteAlert = () => {
    setDeleteAlert(!deleteAlert);
  }
  const handleReportAlert = () => {
    setShowReport(!showReport)
  }

  const handleDeleteConversation = async () => {
    const headers = headerProvider();
    const requestOptions = {
      method: "DELETE",
      headers,
    };
    const response = await deleteConversation(conversation?.id, requestOptions);
    if (response && response.success) {
      showToastMessage(
        "Deleted",
        "Conversation has been deleted successfully.",
        "success",
        toast
      );
      Navigate('/conversations', { replace: true });
    } else {
      showToastMessage(
        response ? "Failed" : "Server Error",
        response ? response?.response?.errors[0] : "The server is not responding. Please try later!",
        "error",
        toast
      );
      handleDeleteAlert();
    }
  }
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "40px"; // Reset height
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = `${Math.min(scrollHeight, 200)}px`; // Expand but limit to 200px
    }
  }, [replyToUser.replyMessage]);

  const renderModal = () => {
    return (
      <Modal
        isOpen={showReport}
        ariaHideApp={false}
        className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50 "
        contentLabel="Delete Modal"
      >
        <div className={`flex flex-col gap-10 relative bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 ${report?.report ? ' w-11/12' : 'min-w-44'} mx-auto min-h-40`}>
          {report?.report ? <div className='flex flex-col gap-10'>
            <div>
              <p className='text-lg'>First Page Report:</p> <p dangerouslySetInnerHTML={{ __html: `${(JSON.parse(report?.report).firstPageReport)}` }} />
            </div>
            <div>
              <p className='text-lg'>Second Page Report:</p> <p dangerouslySetInnerHTML={{ __html: `${(JSON.parse(report?.report).secondPageReport)}` }} />
            </div>
          </div>
            :
            <div>
              <p>No report is available for this conversation.</p>
            </div>
          }
          <div className='flex justify-end'>
            <button
              onClick={handleReportAlert}
              type="button"
              className="py-2 px-6 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:text-red-300 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    )
  }
  return (
    <div className='flex'>
      <aside className="h-screen sticky top-0 basis-1/5">
        <Sidebar />
      </aside>
      <main className='basis-4/5'>
        <div className='flex flex-col'>
          {loader ? <div className='flex justify-center self-center mt-64'>
            <Spinner
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              color='blue.500'
              size='xl'
            />
          </div>
            :
            <div>
              <nav className='border borderblack flex-no-wrap h-32 relative flex w-full items-center justify-between bg-[#f4f7fe] py-2 shadow-md shadow-black/5 dark:bg-neutral-600 dark:shadow-black/10 lg:flex-wrap lg:justify-start lg:py-4'>
                <div className='flex justify-between h-20 w-full'>
                  <div className='items-center p-3'>
                    <Tooltip title={conversation?.userName} placement='top'>
                      <p className='text-sm font-semibold'>{`Username: ${conversation?.userName?.slice(0, 12)}`}</p>
                    </Tooltip>
                    <p className='text-sm font-semibold'>{
                      `Status: ${!conversation?.isActive ? 'Completed' :
                        currentDate > (new Date(conversation.expiringOn).toLocaleDateString()) && conversation.isActive
                          ? 'Expired' : 'In Progress'
                      }`}
                    </p>
                  </div>
                  <div className="items-center p-3">
                    <div className="text-sm font-semibold">
                      <p>Therapist Name</p>
                    </div>
                    {isEditingTherapistName ? (
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={volunteerName}
                          onChange={(e) => setVolunteerName(e.target.value)}
                          className="text-sm px-2 py-1 border-b border-gray-400 focus:outline-none bg-transparent"
                        />
                        {volunteerName ? <button onClick={handleTherapistSave}>
                          <FaCheck size={20} />
                        </button>
                          :
                          <button>
                            <IoClose size={20} onClick={() => setIsEditingTherapistName(false)} />
                          </button>
                        }
                      </div>
                    ) : (
                      <div className='flex gap-2'>
                        <p className={`text-sm font-semibold`}>
                          {volunteerName
                            ? volunteerName
                            : conversation?.volunteerName
                              ? conversation?.volunteerName
                              : conversation?.therapistName}
                        </p>
                        {!conversation?.volunteerName && !volunteerName && <MdEdit
                          onClick={() =>
                            setIsEditingTherapistName(!conversation?.volunteerName && !volunteerName && true)
                          }
                          className={`${!conversation?.volunteerName && 'cursor-pointer hover:underline'}`} size={18}
                        />}
                      </div>
                    )}
                  </div>
                  <div className='items-center p-3'>
                    <p className='text-sm font-semibold'>{`Age`}</p>
                    <p className='text-sm font-semibold'>{`${conversation?.userAge ? conversation?.userAge : 'NA'}`}</p>
                  </div>
                  <div className='items-center p-3'>
                    <p className='text-sm font-semibold'>{`Gender`}</p>
                    <p className='text-sm font-semibold'>{`${conversation?.userGender ? conversation?.userGender : 'NA'}`}</p>
                  </div>
                  <div className='items-center p-3'>
                    <p className='text-sm font-semibold'>{`Location`}</p>
                    <p className='text-sm font-semibold'>{`${conversation?.userLocation ? conversation?.userLocation : 'NA'}`}</p>
                  </div>
                  <div className='items-center p-3'>
                    <p className='text-sm font-semibold'>{`User Id`}</p>
                    <p className='text-sm font-semibold'>{`${conversation?.userIdentifier ? conversation?.userIdentifier : 'NA'}`}</p>
                  </div>
                  <div className='items-center p-3'>
                    <p className='text-sm font-semibold'>{`Bookmark`}</p>
                    <button onClick={handleBookmarkToggle}>
                      {
                        console.log("================", isBookmarked)
                      }
                      {isBookmarked ? (
                        <FaBookmark className="ml-5" size={20} />
                      ) : (
                        <FaRegBookmark className="ml-5" size={20} />
                      )}
                    </button>
                  </div>
                  <div className="p-3 flex items-center">
                    {conversation?.messages?.length % 2 !== 0 && <div>
                      <button
                        onClick={handleButtonClick}
                        type="button"
                        className="py-2.5 ml-4 px-5 mb-2 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-blue dark:hover:bg-gray-700"
                      >
                        Attach Audio
                      </button>
                      <input
                        type="file"
                        accept="audio/*,video/mp4"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                      />
                      <Modal
                        isOpen={isAudioURL}
                        ariaHideApp={false}
                        className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50 "
                        contentLabel="Delete Modal"
                      >
                        <div className={`flex flex-col gap-10 relative bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 min-w-44 mx-auto min-h-40`}>
                          <div className='flex flex-col gap-10'>
                            <p>Audio Preview:</p>
                            <ReactAudioPlayer
                              src={audioURL}
                              autoPlay={false}
                              controls
                            />
                            <div className='flex justify-end gap-4'>
                              <button
                                onClick={() => setIsAudioURL(false)}
                                type="button"
                                className="py-2 px-6 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:text-red-300 transition-colors"
                              >
                                Close
                              </button>
                              <button
                                onClick={handleSendAudio}
                                type="button"
                                className="py-2 px-6 text-sm font-medium bg-blue-500 text-white rounded-md hover:bg-blue-600"
                              >
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>}
                    <button
                      onClick={handleReportAlert}
                      type="button"
                      className="py-2.5 ml-4 px-5 mb-2 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-blue dark:hover:bg-gray-700"
                    >
                      Report
                    </button>
                    <button
                      onClick={handleDeleteAlert}
                      type="button"
                      className="py-2.5 px-5 mx-4 mb-2 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-red-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-red dark:hover:bg-gray-700"
                    >
                      Delete
                    </button>
                    {renderModal()}
                    <Modal
                      isOpen={deleteAlert}
                      ariaHideApp={false}
                      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
                      contentLabel="Delete Modal"
                    >
                      <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md mx-auto">
                        <div className="flex flex-col items-center">
                          <p className="text-base font-medium text-gray-800 dark:text-gray-100 mb-6">
                            Are you sure you want to delete this conversation?
                          </p>
                          <div className="flex justify-center gap-4">
                            <button
                              onClick={handleDeleteConversation}
                              type="button"
                              className="py-2 px-6 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                            >
                              Yes
                            </button>
                            <button
                              onClick={handleDeleteAlert}
                              type="button"
                              className="py-2 px-6 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-red-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:text-red-300 transition-colors"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </Modal>
                    <Modal
                      isOpen={showModal}
                      ariaHideApp={false}
                      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
                      contentLabel="Reply Modal"
                    >
                      <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 w-2/3 h-auto">
                        <div className="cursor-pointer absolute top-2 right-2 text-gray-700 dark:text-gray-300 hover:text-red-500">
                          <IoClose size={30} onClick={openModal} />
                        </div>
                        <Formik
                          initialValues={{
                            replyMessage: "",
                          }}
                          onSubmit={async (values, { setSubmitting }) => {
                            let replyText = formatTextWithLinks(replyToUser.replyMessage)
                            const data = { text: replyText };
                            const headers = headerProvider();
                            const requestOptions = {
                              method: "POST",
                              headers,
                              body: JSON.stringify(data),
                            };
                            const response = await replyToConversation(
                              conversation?.id,
                              requestOptions
                            );
                            if (response) {
                              if (response.success) {
                                showToastMessage(
                                  response.response.title,
                                  response.response.description,
                                  "success",
                                  toast
                                );
                                setShowModal(false);
                              } else {
                                showToastMessage(
                                  "Message was not sent",
                                  response.response.errors[0],
                                  "error",
                                  toast
                                );
                              }
                            } else {
                              showToastMessage(
                                "Server Error",
                                "The server is not responding. Please try later!",
                                "error",
                                toast
                              );
                            }
                            setReplyToUser({
                              replyMessage: "",
                            });
                            setSubmitting(false);
                          }}
                        >
                          {({ isSubmitting }) => (
                            <Form className="p-4">
                              <div className="mb-4">
                                <label
                                  className="block text-gray-700 dark:text-gray-300 mb-2"
                                  htmlFor="replyMessage"
                                >
                                  Please reivew your message before sending
                                </label>
                                <div className="max-h-80 overflow-y-auto min-h-40 p-4 border border-gray-300 rounded-lg">
                                  <p className="text-base break-words whitespace-pre-wrap">
                                    {replyToUser.replyMessage}
                                  </p>
                                </div>
                              </div>
                              <div className="flex justify-end">
                                <button
                                  type="submit"
                                  disabled={!replyToUser.replyMessage}
                                  className={`w-full h-10 hover:bg-blue-600 rounded-md ${replyToUser.replyMessage
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-300 text-gray-500"
                                    }`}
                                >
                                  Send
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </Modal>
                  </div>
                </div>
              </nav>
              <div className='mb-28'>
                {
                  conversation?.messages.map((item) => {
                    return <div key={item.id} className={`${item?.therapistId !== null && 'justify-end'} w-full flex`}>
                      <div className={`${item?.therapistId !== null ? 'bg-sky-300' : 'bg-slate-100'} px-4 py-2 max-w-xl rounded-md overflow-hidden shadow-lg mt-5 ml-8 mr-8`}>
                        <div className="">
                          <div className="text-gray-700 text-sm" dangerouslySetInnerHTML={{ __html: item?.text }}                    >
                          </div>
                          {item?.url && (
                            <div className="mt-2 flex flex-row items-center gap-4">

                              {/* CAF audio player */}
                              <ReactAudioPlayer src={item?.url} controls/>

                              {/* Clean black download icon */}
                              <a
                                href={item.url}
                                download={`audio-${item.id}.m4a`}
                                className="mt-2 text-black hover:text-gray-700"
                                title="Download audio"
                              >
                                <IoMdDownload size={22} />
                              </a>

                            </div>
                          )}
                        </div>
                        <div className={`flex border-black ${item?.therapistId === null ? 'justify-end' : 'justify-between'}`}>
                          {item?.therapistId !== null && (
                            <div className='mr-4 text-xs font-semibold mt-2 flex items-center'>
                              Feedback Response:
                              {item?.feedbackResponse ? (
                                <div className="flex ml-2">
                                  {[...Array(parseInt(item.feedbackResponse))].map((_, index) => (
                                    <IoMdStar key={index} size={16} />
                                  ))}
                                </div>
                              ) : (
                                <span className="ml-2">NA</span>
                              )}
                            </div>
                          )}
                          <p className='mr-4 text-xs font-semibold mt-2'>
                            {new Date(item?.date).toLocaleDateString()}, {new Date(item?.date).toLocaleTimeString()}
                          </p>
                        </div>
                      </div>
                    </div>
                  })
                }
              </div>
            </div>
          }
          {
            conversation?.messages?.length % 2 !== 0 &&
            <div className="flex flex-row gap-4 fixed bottom-0 w-full bg-white p-4 border border-gray-300">
              <div className='w-3/5'>
                <textarea
                  ref={textareaRef}
                  name='replyMessage'
                  value={replyToUser.replyMessage}
                  onChange={handleChange}
                  placeholder="Type a message..."
                  className="p-2 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none overflow-y-auto min-h-[40px] max-h-[200px]"
                  rows="1"
                ></textarea>
              </div>
              <div className='w-40'>
                <button
                  onClick={openModal}
                  className={`w-full text-white px-4 py-2 rounded-lg hover:bg-blue-600 ${replyToUser.replyMessage
                    ? "bg-blue-500 text-white"
                    : "bg-blue-300 text-gray-500"
                    }`}
                  disabled={!replyToUser.replyMessage}
                >
                  Review
                </button>
              </div>
            </div>
          }
        </div>
      </main>
    </div>
  );
};

export default SingleConversation;
